import * as angular from "angular";
import {IController} from "angular";

export class auctionOfferStatusCtrl implements IController {

  status: any;

  private statusColors: any;
  private backColor: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.statusColors = {
      Assigned : 'green-800',
      Accepted : 'green-300',
      Waiting : 'blue-300',
      Started : 'blue-A700',
      Expired : 'red-300',
      Rejected : 'red-500',
      Canceled : 'grey-600'
    };
    this.backColor = this.statusColors[this.status];
  }

  $onChanges(changes) {
    if (changes.status && !changes.status.isFirstChange()) {
      this.backColor = this.statusColors[this.status];
    }
  }

}

angular
  .module('bringoz.admin.auctions')
  .component('auctionOfferStatus', {
    bindings: {
      status: '='
    },
    template: require('./auction-offer-status.html').default,
    controller: auctionOfferStatusCtrl
  });
